import { LinearProgress } from '@mui/material';
import { appRoutes } from 'app/app-routes';
import { UserActionCodeValues } from 'common/types/user-action-code';
import { Formik } from 'formik';
import { UserActionCode, useUsersVerifyPasswordCodeMutation } from 'graphql/generated';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { cacheActions } from 'redux/cache.slice';
import { WsFormTextField } from 'stories/forms/WsFormTextField';
import { WsButton } from 'stories/inputs/WsButton';
import WsFormBox from 'stories/layout/WsFormBox';
import WsFormInfoContainer from 'stories/layout/WsFormInfoContainer';
import WsPanel from 'stories/layout/WsPanel';
import * as yup from 'yup';

type RouteParams = Record<'email', string>;

interface FormValues {
  code: string;
}

const validationSchema = yup.object().shape({
  code: yup.string().required('Required'),
});

const CheckPasswordCode = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { email } = useParams<RouteParams>();

  const [verifyPasswordCode] = useUsersVerifyPasswordCodeMutation();

  const formAction = async (formValues: FormValues, setSubmitting: (isSubmitting: boolean) => void) => {
    try {
      if (email) {
        setSubmitting(true);
        const data = await verifyPasswordCode({
          variables: { email: email as string, code: formValues.code },
        });
        setSubmitting(false);
        if (!data.data) throw new Error('Register user error');
        const result = data.data.usersVerifyPasswordCode;
        if (result.code === UserActionCode.verified) {
          if (result.user) {
            const { __typename, ...user } = result.user;
          }
          dispatch(cacheActions.pwCode(formValues.code));
          navigate(`${appRoutes.changePassword}/${result.user?.id}/${formValues.code}`);
        } else throw new Error(UserActionCodeValues[result.code]);
      }
    } catch (error: any) {
      setSubmitting(false);
      dispatch(
        cacheActions.addSnack({
          message: error.message,
          variant: 'error',
        }),
      );
    }
  };

  return (
    <Formik
      validationSchema={validationSchema}
      initialValues={{
        code: '',
      }}
      onSubmit={(values, { setSubmitting }) => formAction(values, setSubmitting)}
    >
      {props => (
        <form onSubmit={props.handleSubmit}>
          <WsPanel width="340px" title="Change Password">
            <WsFormInfoContainer>Enter the reset code emailed to you.</WsFormInfoContainer>
            <WsFormBox>
              <WsFormTextField id="code" label="Reset Code" type="text" formik={props} />
              {props.isSubmitting && <LinearProgress />}
              <WsButton label="Check Clode" type="submit" disabled={props.isSubmitting} />
            </WsFormBox>
          </WsPanel>
        </form>
      )}
    </Formik>
  );
};

export default CheckPasswordCode;
